export const links = {
  booking: 'https://cal.com/craig-thomas-f2ucgl/30min',
  linkedin: 'https://www.linkedin.com/in/craig-thomas-1450b66/',
  magicPatterns: 'https://www.magicpatterns.com',
  logo: 'https://cdn.magicpatterns.com/uploads/a3btAFAuYcXWANqhXGzBkw/thomasconsulting.png',
  portrait:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/8oFFmEna3CRhNnzzoDmmFQ/1545923747529.jpg',
}

export const bookingLabel = 'Book an introductory conversation'

// Replace with your GA4 Measurement ID (Google Analytics > Admin > Data streams)
export const analyticsConfig = {
  measurementId: 'G-P55PE9WGBR',
}

export const navItems = [
  { label: 'Experience', id: 'experience' },
  { label: 'Working together', id: 'working-together' },
  { label: 'About', id: 'about' },
]

export const situations = [
  {
    icon: 'stuck',
    title: 'An important initiative is stuck.',
    body: 'The priority is clear, but progress keeps slipping. We clarify decisions, establish ownership, and get the work moving.',
  },
  {
    icon: 'alignment',
    title: 'Your leadership team needs alignment.',
    body: 'Unclear roles or unresolved disagreements are slowing the organization down. We build shared expectations and follow-through.',
  },
  {
    icon: 'operations',
    title: 'Operations need to catch up.',
    body: 'Growth has stretched your systems. We simplify processes and connect everyday work to the priorities that matter.',
  },
  {
    icon: 'transition',
    title: 'You’re navigating a transition.',
    body: 'A leadership change or new direction needs experienced support while the team builds the capacity for what comes next.',
  },
] as const

export const experience = [
  {
    id: 'fully',
    label: 'Fully · COO and President',
    title: 'Leading growth and change',
    intro:
      'Helped lead the business through more than sixfold growth, international expansion, and acquisition, building the teams and systems to support it.',
    detail:
      'Responsibilities spanned finance, sales, marketing, supply chain, logistics, people, and technology. That breadth informs how I diagnose problems that cross functional boundaries.',
  },
  {
    id: 'wild-salmon-center',
    label: 'Wild Salmon Center · Transformation',
    title: 'Connecting strategy, people, and execution',
    intro:
      'Strengthened executive alignment, led a senior leadership transition, and built an integrated approach to workplanning and budgeting.',
    detail:
      'The engagement evolved as the organization’s needs became clearer. Shared values, clearer responsibilities, and practical systems gave the team a stronger foundation to carry the work forward.',
  },
  {
    id: 'lovett',
    label: 'Lovett Deconstruction · Business transformation',
    title: 'Making the decisions that restore profitability',
    intro:
      'Helped owners clarify expectations, establish useful metrics, and navigate structural changes projected to improve annual profitability by roughly $600,000.',
    detail:
      'Leadership coaching and practical operating support helped the owners evaluate difficult choices and lead the company through significant changes.',
  },
  {
    id: 'almond-clear',
    label: 'Almond Clear · Founder advisory',
    title: 'A stronger business and a more confident leader',
    intro:
      'Supported decisions on pricing, hiring, manufacturing, and formula ownership. The business grew more than 200% over the following two years.',
    detail:
      'The work reduced reliance on a single manufacturer, strengthened team practices, and helped the founder develop the judgment to lead more independently.',
  },
]

export const testimonials = [
  {
    id: 'guido-rahr',
    name: 'Guido Rahr',
    role: 'CEO, Wild Salmon Center',
    lead: 'Craig could move between working with staff and advising the executive team, and when a decision was made, he didn’t stop at making recommendations.',
    paragraphs: [
      'Craig could move between working with staff and advising the executive team, and when a decision was made, he didn’t stop at making recommendations. He was willing to roll up his sleeves and help make it happen. Just as importantly, he built the work in a way that our team could carry forward without depending on him. He brought an experienced, objective perspective to several consequential decisions and left us with stronger leadership and systems.',
    ],
  },
  {
    id: 'leslie-eisen',
    name: 'Leslie Eisen',
    role: 'Founder and CEO, Almond Clear',
    lead: 'Working with Craig helped me move from feeling stressed and uncertain to making consequential decisions with confidence.',
    paragraphs: [
      'Working with Craig helped me move from feeling stressed and uncertain to making consequential decisions with confidence. He helped me focus on the few moves that mattered most—from pricing and hiring to changing manufacturers and securing ownership of our formulas.',
      'Our business has grown more than 200% in two years, with stronger team systems and much less operational risk. Just as important, Craig helped me develop the judgment and confidence to lead independently. I still have business challenges, but they’re much better problems to have.',
    ],
  },
  {
    id: 'der-lovett',
    name: 'Der Lovett',
    role: 'Owner, Lovett Deconstruction',
    lead: 'Craig helped us clarify expectations, develop meaningful metrics, and navigate several swift and significant changes to our company structure.',
    paragraphs: [
      'Craig helped us clarify expectations, develop meaningful metrics, and navigate several swift and significant changes to our company structure. Those changes proved to be both correct and imperative. His experience and support gave us the confidence to trust our vision and instincts when we needed an experienced, objective perspective.',
    ],
  },
]

export const steps = [
  {
    number: '01',
    verb: 'Talk',
    title: 'Explore the situation',
    body: 'An initial conversation about what’s happening, what you’re trying to accomplish, and where progress is getting difficult.',
    detail: 'Complimentary 30-minute introductory conversation',
  },
  {
    number: '02',
    verb: 'Assess',
    title: 'Find the real constraint',
    body: 'A focused assessment with written findings and a recommended approach, scope, and duration for the engagement.',
    detail: '$1,000 · credited to your first retainer month',
  },
  {
    number: '03',
    verb: 'Lead',
    title: 'Work through the change',
    body: 'I work alongside your team to lead implementation and build the systems and leadership habits to sustain progress.',
    detail: 'Starting from $9,000 per month',
  },
]
